import { useEffect, useState } from 'react';
import Select, { components } from 'react-select';

// FormSelect marks a field with these classes, as for text inputs. The control's border is an inline
// style, so a class on the wrapper never reached it: read the state from the class names instead.
const ERROR_BORDER = '0.2rem solid #d64444';
const VALID_BORDER = '0.2rem solid #298700';
const DEFAULT_BORDER = '1px solid #b9bed0';
const hasClass = (className, name) => (className || '').split(/\s+/).includes(name);

const CustomSelect = ({ ref, id, className, placeholder = '', options, row, ...rest }) => {
  const hasError = hasClass(className, 'border_red');
  const isValid = hasClass(className, 'border_green');
  const [optionVal, setOptionVal] = useState(options?.slice(0, 51));
  useEffect(() => {
    setOptionVal(options?.slice(0, 51));
  }, [options]);
  if (!(options || [])?.[0]?.label || !(options || [])?.[0]?.value) {
    options = options.reduce((acc, cur) => [...acc, { label: cur.option, value: cur.option }], []);
  }

  const handleInputChange = inputValue => {
    const filteredOptions = options
      ?.reduce((acc, cur) => [...acc, { label: cur?.label, value: cur?.label }], [])
      ?.filter(option => {
        return option?.label?.toLowerCase().includes(inputValue?.toLowerCase());
      });
    setOptionVal(filteredOptions?.slice(0, 51));
  };
  return (
    <Select
      className="react_dropdown"
      styles={{
        dropdownIndicator: (baseStyles, state) => ({
          ...baseStyles,
          transform: state.selectProps.menuIsOpen ? 'rotate(180deg)' : '',
          zIndex: '1',
          cursor: 'pointer',
        }),
        control: (baseStyles, state) => ({
          ...baseStyles,
          borderRadius: '4px',
          border: hasError ? ERROR_BORDER : isValid ? VALID_BORDER : DEFAULT_BORDER,
          background: '#fff',
          height: '48px',
          boxSizing: 'border-box',
        }),
        valueContainer: (baseStyles, state) => ({
          ...baseStyles,
          padding: '0px 12px',
          height: '100%',
          boxSizing: 'border-box',
        }),
        placeholder: (baseStyles, state) => ({
          ...baseStyles,
          fontSize: '16px',
          fontFamily: 'Montserrat_regular',
          fontWeight: 400,
          color: '#1d1d1d',
          opacity: '0.5',
        }),
        input: (baseStyles, state) => ({
          ...baseStyles,
          fontSize: '16px',
          color: '#000',
          padding: '0px',
          position: 'absolute',
        }),

        indicatorContainer: (baseStyles, state) => ({
          ...baseStyles,
          padding: '8px 16px 8px 0',
          display: 'none',
        }),
        singleValue: (baseStyles, state) => ({
          ...baseStyles,
          fontSize: '16px',
          fontFamily: 'Montserrat_thin',
          color: '#4f4f4f',
          color: '#1d1d1d',
          fontFamily: 'Montserrat_regular',
          fontWeight: 500,
        }),

        indicatorSeparator: (baseStyles, state) => ({
          ...baseStyles,
          display: 'none',
        }),

        menu: (baseStyles, state) => ({
          ...baseStyles,
          zIndex: '11',
        }),

        menuList: (baseStyles, state) => ({
          ...baseStyles,
          borderRadius: '4px',
          border: '1px solid var(--grey-colors-grey-4, #bdbdbd)',
          boxShadow: '0px 0px 30px 0px rgba(116, 116, 116, 0.15)',
        }),
        option: (baseStyles, state) => {
          return {
            ...baseStyles,
            color: '#333333',
            fontSize: '14px',
            fontWeight: '700',
            lineHeight: '150%',
            cursor: 'pointer',
            backgroundColor: state.isSelected ? '#b6d4f8' : '',
            ':hover': {
              backgroundColor: '#b6d4f8',
            },
          };
        },
      }}
      ref={ref}
      // The id goes on the focusable input so a <label htmlFor={id}> names the combobox.
      // react-select would otherwise put it on its wrapper div, which a label cannot point at.
      id={id ? `${id}-container` : undefined}
      inputId={id}
      aria-invalid={hasError || undefined}
      options={optionVal}
      {...rest}
      placeholder={placeholder}
      value={rest.value && { value: rest.value, label: rest.value }}
      isSearchable={true}
      onInputChange={handleInputChange}
    />
  );
};

export default CustomSelect;
